module.exports = __webpack_public_path__ + "static/pic02-4a459e4a3b24aa474ee3bcf622792861.jpg";